import React from 'react'
import { Badge, Card } from 'react-bootstrap'

function MealCard({ title, count, trend, status, time, icon, color }) {
  return (
<Card className="border-0 shadow-sm p-3">
    <div className="d-flex justify-content-between align-items-start">
      <div className="rounded-circle p-3" style={{ backgroundColor: color }}>{icon}</div>
      <Badge bg="light" text="dark" className="border">{status}</Badge>
    </div>
    <h6 className="mt-3 text-muted">{title}</h6>
    <div className="d-flex align-items-baseline">
      <h2 className="fw-bold mb-0 me-2">{count}</h2>
      {/* <small className={trend.includes('-') ? 'text-danger' : 'text-success'}>{trend}</small> */}
    </div>
    {/* <small className="text-muted mt-2">المتوقع لـ {time}</small> */}
  </Card>  )
}

export default MealCard